const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initializeEditorialMotion(root = document) {
  if (reducedMotion) return;

  const sections = [...root.querySelectorAll('main > .shopify-section')].filter(
    (section, index) => index > 0 && !section.dataset.editorialMotionInitialized,
  );

  if (!sections.length) return;

  document.documentElement.classList.add('editorial-motion-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('editorial-motion-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
  );

  for (const section of sections) {
    section.dataset.editorialMotionInitialized = 'true';
    observer.observe(section);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeEditorialMotion(), { once: true });
} else {
  initializeEditorialMotion();
}

document.addEventListener('shopify:section:load', (event) => initializeEditorialMotion(event.target));
